const services = {
  "services": [
    {
      "id": 1,  
      "title": "Consultoría y Estrategia de Producto",
      "landing": true,
      "description": "Antes de escribir una sola línea de código, pensamos. Te ayudamos a definir qué construir, cómo hacerlo y por qué, para evitar decisiones caras en el futuro y asegurar que el producto tenga sentido a nivel de negocio, tecnología y usuario.",
      "list": [
        "Definición y validación de ideas de producto",
        "Análisis de necesidades y objetivos reales",
        "Elección de tecnologías y arquitectura",
        "Roadmap técnico y de evolución",
        "Auditoría de software existente"
      ],
      "closeMessage": "Ideal si tienes una idea, un producto que no termina de encajar o un sistema que ha crecido sin una dirección clara.",
      "image": "/icons/design-svgrepo.svg"
    },
    {
      "id": 2,
      "title": "Desarrollo de Software a Medida",
      "landing": true,
      "description": "Construimos productos digitales sólidos, escalables y adaptados a cada proyecto. Nada de plantillas: cada solución se diseña y desarrolla a medida, con una base técnica pensada para evolucionar sin romperse.",
      "list": [
        "Aplicaciones web",
        "Aplicaciones móviles",
        "Software empresarial",
        "Herramientas internas",
        "MVPs y productos en fase inicial",
        "Integraciones con servicios externos y APIs"
      ],
      "closeMessage": "El desarrollo no es solo ejecutar: es tomar buenas decisiones desde el principio.",
      "image": "/icons/software-platform.svg"
    },
    {
      "id": 3,
      "title": "Arquitectura, Backend y Escalabilidad",
      "landing": false,
      "description": "Cuando un producto crece, los problemas técnicos aparecen. Diseñamos y mejoramos arquitecturas que permiten escalar, mantener y operar el software con fiabilidad incluso cuando aumenta la complejidad.",
      "list": [
        "Diseño y revisión de arquitectura",
        "Desarrollo y optimización de backend",
        "APIs REST y GraphQL",
        "Migraciones y reestructuración de sistemas",
        "Mejora de rendimiento y estabilidad"
      ],
      "closeMessage": "Especialmente útil para productos en producción que necesitan dar el siguiente paso.",
      "image": "/icons/server.svg"
    },
    {
      "id": 4,
      "title": "Acompañamiento Técnico y CTO Externo",
      "landing": true,
      "description": "Si no necesitas un equipo técnico interno a tiempo completo, actuamos como apoyo estratégico. Acompañamos en decisiones clave, aportando experiencia senior y una visión de largo plazo.",
      "list": [
        "CTO externo o fractional CTO",
        "Apoyo a equipos de desarrollo internos",
        "Revisión de decisiones técnicas",
        "Mentoring y orientación tecnológica",
        "Planificación de crecimiento y escalado"
      ],
      "closeMessage": "Una forma de tener criterio técnico senior sin asumir estructuras innecesarias.",
      "image": "/icons/annotation-user.svg"
    },
    {
      "id": 5,
      "title": "UX / UI y Diseño de Producto",
      "landing": false,
      "description": "Un buen producto no solo funciona: se entiende. Integramos diseño de experiencia e interfaz como parte natural del proceso para que el software sea usable, coherente y alineado con los objetivos del negocio.",
      "list": [
        "UX y arquitectura de la información",
        "UI y diseño visual",
        "Wireframes y prototipos",
        "Testing de usabilidad",
        "Sistemas de diseño"
      ],
      "closeMessage": "Diseño al servicio del producto, nunca como algo superficial.",
      "image": "/icons/brush.svg"
    },
    {
      "id": 6,
      "title": "Automatización e Inteligencia Artificial",
      "landing": false,
      "description": "Aplicamos automatización e IA cuando realmente aportan valor: menos tareas manuales, procesos más rápidos y herramientas que ayudan a tomar mejores decisiones.",
      "list": [
        "Automatización de procesos internos",
        "Integración de IA en productos existentes",
        "Chatbots y asistentes inteligentes",
        "Procesamiento y análisis de datos",
        "Dashboards y apoyo a decisiones"
      ],
      "closeMessage": "Tecnología útil, sin complejidad innecesaria ni humo.",
      "image": "/icons/ai.svg"
    }
  ]
}

export default services;